import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Admin es superset. Puede entrar a rutas de paciente y de médico usando
// su propia cuenta (mismo user_id). Sólo /admin sigue restringido a admin.
// El backend impone la misma regla en `require_role` (auth_routes.py).
export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <div className="flex items-center gap-2 text-muted-foreground text-sm">
          <Loader2 className="animate-spin" size={16} /> Cargando…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (role && user.role !== role) {
    // Admin passes through any role gate (except no-op — same role).
    if (user.role === "admin") {
      return children;
    }
    // Non-admin trying to access a route of another role → redirect home.
    const target =
      user.role === "medico" ? "/medico" : "/dashboard";
    return <Navigate to={target} replace />;
  }

  return children;
}
